import React from "react";
import Styled from "../PageOne/PageOne";
import TextStyles from "../../../../../../Constants/TextStyles";

const ListAddClause = ({ data }) => {
  const heading = data && data.heading ? data.heading : "";

  const paragraph = data && data.paragraph ? data.paragraph : "";

  return (
    <div
      style={{
        display: data && data.required === true ? "inline" : "none",
      }}
    >
      <Styled.ReviewContentBox>
        <TextStyles.FontSize20px className="mb-3 fw-medium overflow-hidden">
          {heading}
        </TextStyles.FontSize20px>
        <TextStyles.FontSize14px className="lh-lg overflow-hidden" style={{ whiteSpace: "break-spaces" }}>
          {paragraph}
        </TextStyles.FontSize14px>
      </Styled.ReviewContentBox>
    </div>
  );
};

export default ListAddClause;
